import { ReactNode } from 'react';
import { NavigateFunction } from 'react-router-dom';
import styled from 'styled-components';

export const WrestlerLink = styled.span`
  color: gold;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: darkgoldenrod;
  }
`;

const WRESTLER_TAG_REGEX = /\[wrestler:(\d+)\](.*?)\[\/wrestler\]/g;

/**
 * Parsifica i tag wrestler nel testo e li trasforma in link cliccabili
 * @param text - Il testo contenente i tag [wrestler:id]nome[/wrestler]
 * @param navigate - La funzione navigate di react-router
 * @param onNavigate - Callback chiamata prima della navigazione
 * @returns Array di ReactNode con testo e link wrestler
 */
export function parseWrestlerTags(
  text: string,
  navigate: NavigateFunction,
  onNavigate: () => void
): ReactNode[] {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = WRESTLER_TAG_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const wrestlerId = match[1];
    const wrestlerName = match[2];
    const url = `/wrestlers/i_${wrestlerId}_d_${wrestlerName}`;
    parts.push(
      <WrestlerLink
        key={`wrestler-${wrestlerId}-${match.index}`}
        onClick={(e) => {
          e.stopPropagation();
          onNavigate();
          navigate(url);
        }}
      >
        {wrestlerName}
      </WrestlerLink>
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  WRESTLER_TAG_REGEX.lastIndex = 0;

  return parts.length > 0 ? parts : [text];
}
